/**
 * Contact source values
 */
export enum ContactSourceEnum {
	BROKER = 'broker',
	WEBSITE = 'website',
	SOCIAL_MEDIA = 'social_media',
	REFERRAL = 'referral',
	WALK_IN = 'walk_in',
	OTHER = 'other',
}
